import { QRFC } from "./QRFC";

export class QSSOConfigRFC extends QRFC {
  constructor() {
    super();
  }

  InitGetSSOConfigRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "sso/qssorfc";
  }

  SetParams(org, user, mode, data) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("mode", mode);
    this.AddEncodedParameter("data", data);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];

    callBackObj.GetSSOConfigResult(success, r["mapping"], r["code"], r["message"]);
  }
}
